/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { MsgIDs } from '@/defines/MsgIDs'
import { base } from '@/base/base'
import { PopupViews } from '@/defines/EnumDefine'
import { wsClient } from '@/net/WebSocketClient'

export class FreeSpinModule extends ModuleBase {
  private signInfo: any = null
  public signInfoNew: any = null
  public signResult: any = null //签到结果数据

  public nFreeSpinCount = 0 //免费签数目
  onClear(): void {}
  onLoad(): void {}
  onDestroy(): void {}

  init(): void {}

  setSignInfo(info: any) {
    this.signInfo = info
  }

  inits2c(): void {
    ;(hall.s2c as any)['onClientFreeSpinAck'] = function (msg: any) {
      if (msg == null || msg.ret != 0 || msg.UserID != hall.userModule.userId) {
        return
      }

      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新免费转
      hall.eventDispatcher.emit(hall.EventDefine.OnGetFreeSpinInfo, msg)
    }
  }

  onPreloadData(): void {}

  //请求签到活动
  sendGetFreeSpinInfo(): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
    }

    wsClient.send(MsgIDs.ClientFreeSpinReq, msg)
  }

  //点击签到
  sendSignClick(signType: any): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
      SignType: Number(signType),
    }
    wsClient.send(MsgIDs.ClientFreeSpinReq, msg)
  }

  // 是否需要弹窗
  popupView() {
    if (this.nFreeSpinCount > 0) {
      hall.popupViewModule.addPopupView(PopupViews.FreeSpinViewX)
    }
  }
}
